import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, ArrowLeft, Sparkles, Hash, Play, Eye, Flame } from 'lucide-react';
import { API } from '../context/AuthContext';
import { useLang } from '../context/LangContext';

const TagView = () => {
  const { tag } = useParams();
  const { lang } = useLang();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const res = await axios.get(`${API}/tags/${encodeURIComponent(tag)}`); setVideos(res.data.videos || []); }
      catch (_) {} finally { setLoading(false); }
    })();
  }, [tag]);

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10">
        <div className="flex items-center justify-between mb-8">
          <a href="/" className="inline-flex items-center gap-2 text-neutral-500 hover:text-neutral-900 text-[13.5px] font-semibold"><ArrowLeft className="w-4 h-4 rtl:rotate-180" /> {lang === 'sv' ? 'Startsidan' : 'الرئيسية'}</a>
          <div className="flex items-center gap-2"><div className="w-9 h-9 rounded-xl bg-gradient-to-br from-cyan-400 to-fuchsia-500 flex items-center justify-center"><Sparkles className="w-4 h-4 text-white" /></div><span className="font-black text-neutral-900 text-[16px]">CapCute</span></div>
        </div>

        <div className="mb-10">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-fuchsia-500 rounded-full px-3 py-1 mb-3">
            <Hash className="w-3.5 h-3.5 text-white" />
            <span className="text-[11px] font-bold uppercase tracking-wider text-white">{lang === 'sv' ? 'Tag' : 'وسم'}</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black tracking-[-0.02em] text-neutral-900">#{tag}</h1>
          <p className="text-[15px] text-neutral-600 mt-3">{videos.length} {lang === 'sv' ? 'videor' : 'فيديو'}</p>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-cyan-500" /></div>
        ) : videos.length === 0 ? (
          <div className="bg-white rounded-3xl border border-neutral-200 p-14 text-center"><p className="text-neutral-500">{lang === 'sv' ? 'Inga videor med denna tagg än' : 'لا توجد فيديوهات بهذا الوسم'}</p></div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {videos.map(v => (
              <a key={v.id} href={`/v/${v.id}`} className="group relative bg-white rounded-2xl overflow-hidden border border-neutral-200 hover:shadow-xl hover:-translate-y-1 transition-all aspect-[4/5]">
                {v.thumb_path ? <img src={`${API}/files/${v.thumb_path}`} alt={v.title} className="w-full h-full object-cover" /> : <div className="w-full h-full bg-gradient-to-br from-cyan-500 to-fuchsia-500" />}
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"><div className="w-14 h-14 rounded-full bg-white/95 flex items-center justify-center"><Play className="w-5 h-5 fill-black text-black ml-0.5" /></div></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="font-bold text-white text-[13px] truncate">{v.title}</div>
                  <div className="text-white/80 text-[11px] font-semibold flex items-center gap-1 mt-1"><Eye className="w-3 h-3" /> {v.view_count || 0}</div>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TagView;
